import { regionStore } from '../store/jotai/store';
import { toastsAtom, Toast, ToastSeverity } from '../store/jotai/atoms/toast.atom';

let counter = 0;

function addToast(severity: ToastSeverity, title: string, message: string) {
  const toast: Toast = {
    id: `toast-${++counter}-${Date.now()}`,
    severity,
    title,
    message,
    createdAt: Date.now(),
  };

  const current = regionStore.get(toastsAtom);
  regionStore.set(toastsAtom, [...current, toast]);
}

function removeToast(id: string) {
  const current = regionStore.get(toastsAtom);
  regionStore.set(toastsAtom, current.filter((t) => t.id !== id));
}

export const toastr = {
  error: (title: string, message: string) => addToast('error', title, message),
  success: (title: string, message: string) => addToast('success', title, message),
  warning: (title: string, message: string) => addToast('warning', title, message),
  info: (title: string, message: string) => addToast('info', title, message),
};

export { removeToast };
